import { render, staticRenderFns } from "./PlayerButtonWrapper.vue?vue&type=template&id=9d7d7ace&scoped=true&"
import script from "./PlayerButtonWrapper.vue?vue&type=script&lang=ts&"
export * from "./PlayerButtonWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerButtonWrapper.vue?vue&type=style&index=0&id=9d7d7ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7d7ace",
  null
  
)

export default component.exports